import { useQuery } from "@tanstack/react-query";
import { ContractorCardsService } from "@/services/contractorCards";
import { ReadContractorCard } from "@/types/contractorCard";
import { Module } from "@/constants";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";

export const useContractorCardQuery = (
  contractorCardId: string | undefined,
) => {
  const { can_read } = useModulePermissions(Module.ContractorCards);

  const query = useQuery<ReadContractorCard>({
    queryKey: [Module.ContractorCards, contractorCardId],
    queryFn: () => {
      if (!contractorCardId) {
        throw new Error("Contractor card ID is required");
      }
      return ContractorCardsService.get(contractorCardId);
    },
    enabled: !!contractorCardId && can_read,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return {
    ...query,
    contractorCard: query.data,
  };
};
